import { logger } from '@gem/modules/logger';

import { saveScheduledMessage } from 'APP/model/message/messageModel';
import { ChatMessage } from 'STORE/Messages/Message/ChatMessage/ChatMessage';

interface ISendScheduledMessageData {
  groupId: string;
  message: ChatMessage;
  delay: number;
  callback: (result: boolean) => void;
}

export async function sendScheduledMessage(data: ISendScheduledMessageData): Promise<void> {
  try {
    if (data.message.payload.upload) {
      await data.message.payload.upload();
    }

    await saveScheduledMessage({
      ...data.message.toJSON(),
      groupId: data.groupId,
      delay: data.delay,
    });

    data.callback(true);
  } catch (error) {
    logger.get('API').error('messaging.saveScheduledMessage', error);
    data.callback(false);
  }
}
